module.exports = __webpack_public_path__ + "img/icon4.b9541d0d.png";